import { render, staticRenderFns } from "./PorAnoMunicipal.vue?vue&type=template&id=4cb019b2&scoped=true"
import script from "./PorAnoMunicipal.vue?vue&type=script&lang=js"
export * from "./PorAnoMunicipal.vue?vue&type=script&lang=js"
import style0 from "./PorAnoMunicipal.vue?vue&type=style&index=0&id=4cb019b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb019b2",
  null
  
)

export default component.exports